import { Dictionary } from '../../base/dictionary';
import { WUniqueFormat } from '../../base/unique-format';
import { WUniqueFormats } from '../../base/unique-formats';
import { WCharacterFormat } from '../format/character-format';
import { WParagraphFormat } from '../format/paragraph-format';
import { WAbstractList } from './abstract-list';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * @private
 */
export class WListLevel {
    constructor(node) {
        this.uniqueListLevel = undefined;
        this.paragraphFormat = undefined;
        this.characterFormat = undefined;
        if (node instanceof WAbstractList) {
            this.ownerBase = node;
        }
        else {
            this.ownerBase = node;
        }
        this.characterFormat = new WCharacterFormat(undefined);
        this.paragraphFormat = new WParagraphFormat(undefined);
    }
    get listLevelPattern() {
        return this.getPropertyValue('listLevelPattern');
    }
    set listLevelPattern(listLevelPattern) {
        this.setPropertyValue('listLevelPattern', listLevelPattern);
    }
    get followCharacter() {
        return this.getPropertyValue('followCharacter');
    }
    set followCharacter(followCharacter) {
        this.setPropertyValue('followCharacter', followCharacter);
    }
    get startAt() {
        return this.getPropertyValue('startAt');
    }
    set startAt(startAt) {
        this.setPropertyValue('startAt', startAt);
    }
    get numberFormat() {
        return this.getPropertyValue('numberFormat');
    }
    set numberFormat(numberFormat) {
        this.setPropertyValue('numberFormat', numberFormat);
    }
    get paraStyleName() {
        return this.getPropertyValue('paraStyleName');
    }
    set paraStyleName(paraStyleName) {
        this.setPropertyValue('paraStyleName', paraStyleName);
    }
    get restartLevel() {
        return this.getPropertyValue('restartLevel');
    }
    set restartLevel(restartLevel) {
        this.setPropertyValue('restartLevel', restartLevel);
    }
    /**
     * Gets the boolean that specifies that the format for the numbering at this level should be in the decimal format.
     */
    get isLegalStyleNumbering() {
        return this.getPropertyValue('isLegalStyleNumbering');
    }
    /**
     * Sets the boolean that specifies that the format for the numbering at this level should be in the decimal format.
     * @param {boolean} isLegalStyleNumbering - Specifies the value.
     */
    set isLegalStyleNumbering(isLegalStyleNumbering) {
        this.setPropertyValue('isLegalStyleNumbering', isLegalStyleNumbering);
    }
    /* eslint-disable */
    getPropertyValue(property) {
        const propertyType = WUniqueFormat.getPropertyType(WListLevel.uniqueFormatType, property);
        if (!isNullOrUndefined(this.uniqueListLevel) && this.uniqueListLevel.propertiesHash.containsKey(propertyType)) {
            return this.uniqueListLevel.propertiesHash.get(propertyType);
        }
        return WListLevel.getPropertyDefaultValue(property);
    }
    setPropertyValue(property, value) {
        if (isNullOrUndefined(value) || value === '') {
            value = WListLevel.getPropertyDefaultValue(property);
        }
        if (isNullOrUndefined(this.uniqueListLevel)) {
            this.initializeUniqueWListLevel(property, value);
        }
        else {
            const propertyType = WUniqueFormat.getPropertyType(this.uniqueListLevel.uniqueFormatType, property);
            if (this.uniqueListLevel.propertiesHash.containsKey(propertyType) &&
                this.uniqueListLevel.propertiesHash.get(propertyType) === value) { //Do nothing, since no change in property value and return
                return;
            }
            this.uniqueListLevel = WListLevel.uniqueListLevels.updateUniqueFormat(this.uniqueListLevel, property, value);
        }
    }
    initializeUniqueWListLevel(property, propValue) {
        const uniqueListLevelTemp = new Dictionary();
        this.addUniqueWListLevel('listLevelPattern', property, propValue, uniqueListLevelTemp);
        this.addUniqueWListLevel('startAt', property, propValue, uniqueListLevelTemp);
        this.addUniqueWListLevel('followCharacter', property, propValue, uniqueListLevelTemp);
        this.addUniqueWListLevel('numberFormat', property, propValue, uniqueListLevelTemp);
        this.addUniqueWListLevel('paraStyleName', property, propValue, uniqueListLevelTemp);
        this.addUniqueWListLevel('restartLevel', property, propValue, uniqueListLevelTemp);
        this.addUniqueWListLevel('isLegalStyleNumbering', property, propValue, uniqueListLevelTemp);
        this.uniqueListLevel = WListLevel.uniqueListLevels.addUniqueFormat(uniqueListLevelTemp, WListLevel.uniqueFormatType);
    }
    addUniqueWListLevel(property, modifiedProperty, propValue, uniqueCharFormatTemp) {
        let propertyType;
        propertyType = WUniqueFormat.getPropertyType(WListLevel.uniqueFormatType, property);
        if (property === modifiedProperty) {
            uniqueCharFormatTemp.add(propertyType, propValue);
        }
        else {
            uniqueCharFormatTemp.add(propertyType, WListLevel.getPropertyDefaultValue(property));
        }
    }
    static getPropertyDefaultValue(property) {
        /* eslint-disable */
        let value = undefined;
        switch (property) {
            case 'listLevelPattern':
                value = 'Arabic';
                break;
            case 'startAt':
                value = 0;
                break;
            case 'followCharacter':
                value = 'Tab';
                break;
            case 'paraStyleName':
            case 'numberFormat':
                value = '';
                break;
            case 'restartLevel':
                value = 0;
                break;
            case 'isLegalStyleNumbering':
                value = false;
                break;
        }
        return value;
        /* eslint-enable */
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     * @returns {void}
     */
    destroy() {
        if (!isNullOrUndefined(this.uniqueListLevel)) {
            WListLevel.uniqueListLevels.remove(this.uniqueListLevel);
        }
        this.uniqueListLevel = undefined;
        if (!isNullOrUndefined(this.characterFormat)) {
            this.characterFormat.destroy();
            this.characterFormat = undefined;
        }
        if (!isNullOrUndefined(this.paragraphFormat)) {
            this.paragraphFormat.destroy();
            this.paragraphFormat = undefined;
        }
    }
    /**
     * @private
     * @returns {void}
     */
    clearFormat() {
        if (!isNullOrUndefined(this.uniqueListLevel)) {
            WListLevel.uniqueListLevels.remove(this.uniqueListLevel);
        }
        this.uniqueListLevel = undefined;
        if (this.characterFormat) {
            this.characterFormat.clearFormat();
        }
        this.characterFormat = undefined;
        if (this.paragraphFormat) {
            this.paragraphFormat.clearFormat();
        }
        this.paragraphFormat = undefined;
    }
    static clear() {
        this.uniqueListLevels.clear();
    }
    clone(node) {
        const listLevel = new WListLevel(node);
        listLevel.paragraphFormat = this.paragraphFormat.cloneFormat();
        listLevel.characterFormat = this.characterFormat.cloneFormat();
        if (this.uniqueListLevel) {
            listLevel.uniqueListLevel = this.uniqueListLevel;
            listLevel.uniqueListLevel.referenceCount++;
        }
        return listLevel;
    }
}
WListLevel.dotBullet = String.fromCharCode(61623);
WListLevel.squareBullet = String.fromCharCode(61607); //Symbol font \u25aa.
WListLevel.arrowBullet = String.fromCharCode(10148);
WListLevel.circleBullet = String.fromCharCode(61551) + String.fromCharCode(32);
WListLevel.uniqueListLevels = new WUniqueFormats();
WListLevel.uniqueFormatType = 9;
